import { TAccountManagerList } from '../../view-models/account-manager-list.model';
import { TAccount } from './account.model';

let account: TAccount = null;
let accounts: TAccount[] = [];
let accountManagers: TAccountManagerList = [];

export type TAccountExtras = {
  label: string;
  value: string;
};

const industries: TAccountExtras[] = [
  { label: 'education', value: 'EDUCATION' },
  { label: 'marine_commercial', value: 'MARINE_COMMERCIAL' },
  { label: 'marine_cruise', value: 'MARINE_CRUISE' },
  { label: 'marine_small_production', value: 'MARINE_SMALL_PRODUCTION' },
  { label: 'marine_super_yacht', value: 'MARINE_SUPER_YACHT' },
  { label: 'marine_other', value: 'MARINE_OTHER' },
  { label: 'property_commercial', value: 'PROPERTY_COMMERCIAL' },
  { label: 'property_hotel', value: 'PROPERTY_HOTEL' },
  { label: 'property_residential', value: 'PROPERTY_RESIDENTIAL' },
  { label: 'property_other', value: 'PROPERTY_OTHER' },
  { label: 'other', value: 'OTHER' },
];

/** DEPRECATED with feature flag ACCOUNT_MANAGER_API */
export const GET_ACCOUNT_MANAGERS_LIST = (): TAccountExtras[] => [
  {
    value: 'ANDY',
    label: 'Andy Mathewson',
  },
  {
    value: 'VICTORIA',
    label: 'Victoria Thomson',
  },
  {
    value: 'SYRA',
    label: 'Syra Mughul',
  },
  {
    value: 'GARY',
    label: 'Gary Scowen',
  },
  {
    value: 'CHRIS',
    label: 'Chris Trace',
  },
  {
    value: 'ROB',
    label: 'Rob Bailey',
  },
  {
    value: 'AIDEN',
    label: 'Aiden Hurley',
  },
  {
    value: 'KATIE',
    label: 'Katie Spilsbury',
  },
  {
    value: 'LIZZIE',
    label: 'Lizzie Goff',
  },
  {
    value: 'ELA',
    label: 'Ela Ribbans',
  },
  {
    value: 'STUART',
    label: 'Stuart Willis',
  },
  {
    value: 'SAM',
    label: 'Sam Martin',
  },
  {
    value: 'NONE',
    label: 'None',
  },
  {
    value: 'UNSET',
    label: 'Unset',
  },
];

export const GET_ACCOUNT = (): TAccount => account;

export const GET_INDUSTRIES = (): TAccountExtras[] => industries;

export const GET_ACCOUNT_MANAGERS = (): TAccountExtras[] => accountManagers;

export const SET_ACCOUNT = (_account: TAccount): void => {
  account = _account;
};

export const SET_ACCOUNTS = (_accounts: TAccount[]): void => {
  accounts = _accounts;
};

export const SET_ACCOUNT_MANAGERS = (_accountManagers: TAccountManagerList): void => {
  accountManagers = _accountManagers;
};
